import { default as zingchart } from './zingchart-es6.min.js';
let ZC = window.ZC;
export {zingchart as default, ZC};
